const FORBIDDEN_ERROR_TEXT = 'Недостаточно прав';

const getRawErrorText = (error) => {
  if (!error) {
    return '';
  }

  if (typeof error === 'string') {
    return error;
  }

  return error.message || String(error);
};

const sanitizeForbiddenStatus = (message) => {
  if (!message) {
    return '';
  }

  const sanitizedMessage = message
    .replace(/\bhttp error!\s*status:\s*403\b/gi, FORBIDDEN_ERROR_TEXT)
    .replace(/\bhttp\s*403\b/gi, FORBIDDEN_ERROR_TEXT)
    .replace(/\b403\s*forbidden\b/gi, FORBIDDEN_ERROR_TEXT)
    .replace(/\bstatus:\s*403\b/gi, FORBIDDEN_ERROR_TEXT)
    .replace(/\(\s*403\s*\)/g, '')
    .replace(/\b403\b\s*[:;-]?\s*/g, '')
    .replace(/\(\s*\)/g, '')
    .replace(/\s+([.,:;!?])/g, '$1')
    .replace(/\s{2,}/g, ' ')
    .trim();

  return sanitizedMessage || FORBIDDEN_ERROR_TEXT;
};

export const getErrorText = (error) => (
  sanitizeForbiddenStatus(getRawErrorText(error))
);

export const isForbiddenError = (error) => {
  if (error?.status === 403) {
    return true;
  }

  const message = getRawErrorText(error).toLowerCase();

  return (
    message.includes('status: 403') ||
    message.includes('http 403') ||
    message.includes('403 forbidden') ||
    message === 'forbidden' ||
    message.includes('missing permission') ||
    message.includes('permission denied') ||
    message.includes('do not have permission') ||
    message.includes('недостаточно прав')
  );
};
